import { render } from "./SaveAddressInject.vue?vue&type=template&id=21e902ee"
import script from "./SaveAddressInject.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveAddressInject.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/injectComponents/SaveAddressInject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21e902ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21e902ee', __exports__)) {
    api.reload('21e902ee', __exports__)
  }
  
  module.hot.accept("./SaveAddressInject.vue?vue&type=template&id=21e902ee", () => {
    api.rerender('21e902ee', render)
  })

}


export default __exports__